module.exports = __webpack_public_path__ + "graphics/button-minecraft.ckh.947b22e71d812228d3f0ecaaef494db7.svg";